import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function MapPreview({
  value
}) {
  return _jsx(WidgetPreviewContainer, {
    children: value ? value.toString() : null
  });
}
MapPreview.propTypes = {
  value: PropTypes.string
};
export default MapPreview;